import { compile } from 'path-to-regexp'

export const formatRoute = (route, params = {}) => compile(route)(params)

export default {
  dashboard: '/',
  needsAuth: '/needsAuth/',
  login: '/login/',
  logout: '/logout/',
  sessions: '/sessions/',
  sessionNew: '/sessions/new/',
  sessionEdit: '/sessions/:id/edit/',
  settings: '/settings/',
  expenses: '/expenses/',
  expenseNew: '/expenses/new/',
  expenseEdit: '/expenses/:id/edit/',
}
